import { Box, List, ListItem, useTheme } from "@chakra-ui/react";

export const GoalsComponent= (message='') => {
  const theme = useTheme();

  let items = JSON.stringify(message).split('\\');
  if(items.includes('null')){
    items = []
  }
  
  const itemsToShow = items
  .map(item => {
    return item.length > 0 && item[0] !== 'n' ? item : item.slice(1, item.length);
  }).filter(item => {
    return item.length > 0 && item[0] !== 'n' || item[0] === 'n';
  })
  if(items?.length === 0) return null;
  return (
    <Box p={4} bg={theme.background.quaternary} borderBottom={'1px solid'} borderBottomColor={theme.color.text.secondary}>
      <List spacing={3} style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        {itemsToShow.map((item, index) => (
          <ListItem key={index} fontSize="sm" color="gray.700">
            {item.replace('"', '')}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
